import React from 'react';
import { SidebarNotAvailableStyled } from "./styles";
var SidebarNotAvailable = function SidebarNotAvailable() {
  return /*#__PURE__*/React.createElement(SidebarNotAvailableStyled, null, "None");
};
export default SidebarNotAvailable;